import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useAuth } from '@/contexts/AuthContext'
import { LoginForm } from '@/components/auth/LoginForm'

export const Route = createFileRoute('/login')({
  component: LoginPage,
})

function LoginPage() {
  const { isAuthenticated, hasAccess, loading } = useAuth()
  const navigate = useNavigate()

  // Jeśli już zalogowany i ma dostęp — redirect na dashboard
  useEffect(() => {
    if (!loading && isAuthenticated && hasAccess) {
      navigate({ to: '/' })
    }
  }, [loading, isAuthenticated, hasAccess, navigate])

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <LoginForm />
    </div>
  )
}
